<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 >Accueil</h4>
      </div>
    </template>
    <template #content>
      <div class="row pb-4">
        <div class="col-md-7">
          <!-- Titre de la section de réservation -->
          <div class="section-title d-flex align-items-center mb-3">
            <h5 class="text-primary mb-0">Réservation de camion / coursier</h5>
            <div class="dropdown-arrow ml-2">
              <i class="fas fa-chevron-down text-primary"></i>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <CreateReservation></CreateReservation>
            </div>
          </div>

          <div class="card" v-for="course in courses" :key="course.id" style="margin-top: 10px;">
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <span class="badge badge-pill badge-warning">Transport marchandises {{ course.type_course }}</span>
                  <p>Chauffeur principal</p>
                  <div class="d-flex">
                    <div class="">
                      <img src="@/assets/chauffeur.png" style="width: 22px;" />
                    </div>
                    <p class="mx-2">{{ course.chauffeur_principal_nom }} <br>{{ course.chauffeur_principal_telephone1
                    }}</br></p>
                  </div>

                </div>
                <div class="col-8">
                  <div class="" style="text-align: right;">
                    <small>
                      <p>
                        <strong> {{ course.adresse_chargement }} - {{ course.adresse_dechargement }}</strong>
                        <br> Durée du voyage {{ Nbjours(course.date_chargement, course.date_dechargement) }} jours</br>
                        <br>Arrivée le {{ dateFormat(course.date_dechargement) }}</br>
                      </p>
                    </small>
                  </div>

                  <lottie-player autoplay loop mode="normal" style="width: 10%; height: auto;"
                    src="/json/truck_yams.json"></lottie-player>
                  <div class="progress" style="height: 4px;">
                    <div class="progress-bar bg-warning" role="progressbar" style="width: 100%; " aria-valuenow="75"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-5">
          <!-- Titre de la section des statistiques -->
          <div class="section-title d-flex align-items-center mb-3">
            <h5 class="text-primary mb-0">Statistiques</h5>
            <div class="dropdown-arrow ml-2">
              <i class="fas fa-chevron-down text-primary"></i>
            </div>
          </div>

          <div class="card stats-card text-white bg-primary" style="margin-bottom: 10px;">
            <div class="card-body py-4">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 transport-section">
                  <div class="stat-icon">
                    <lottie-player autoplay loop mode="normal" class="lottie-icon"
                      src="/json/camion.json"></lottie-player>
                  </div>
                  <div class="stat-content">
                    <div class="stat-title">Transport de marchandise</div>
                    <div class="stat-value">{{ courses.length }} Courses</div>
                    <!-- <div class="stat-subtitle">Équivalent à 325 T</div> -->
                  </div>
                </div>

                <div class="col-md-6 transport-section">
                  <div class="stat-icon">
                    <lottie-player autoplay loop mode="normal" class="lottie-icon"
                      src="/json/mains.json"></lottie-player>
                  </div>
                  <div class="stat-content">
                    <div class="stat-title">Transport de colis</div>
                    <div class="stat-value">{{ demandes }} Livraisons</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer py-2">
              <router-link class="btn-historique" :to="{ name: 'factures' }">
                Historique de facturation
                <i class="fas fa-chevron-right ml-2"></i>
              </router-link>
            </div>
          </div>

          <div class="card custom-card w-100">
            <div class="card-body d-flex align-items-center">
              <img src="@/assets/logo.png " style="width: 15%;" />
            </div>
            <div class="card-footer bg-primary">
              <div class="d-flex align-items-center #row">
                <div class="mr-2 #col-2">
                  <img src="@/assets/logo1.png" style="width: 50px;" />
                </div>
                <div class="mr-2 #col-md-4 #text-nowrap mr-3">
                  <small> Toute la logistique à portée de main</small>
                </div>
                <!-- <div class="mr-2 #col-md-3">
                  <a href="https://play.google.com/store/apps/details?id=io.ionic.starter.yams" class="">
                    <img src="@/assets/play_store.png" style="width: 100px;" />
                  </a>
                </div>
                <div class="mr-2 #col-md-3 ">
                  <img src="@/assets/app_store.png" style="width: 100px;" />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </yams-template>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment'
import CreateReservation from '@/views/operations/reservations/CreateReservation.vue';

export default defineComponent({
  name: 'HomeView',
  components: { CreateReservation },
  data() {
    return {
      key: 1,
      table: 'demandes',
      isLoading: false,
      resIsLoading: false,
      baseUrl: this.$store.state.api_yams_livraisons,
      courses: [],
      demandes: 0,
      date_dechargement: '',
      date_chargement: '',
    }

  },

  mounted() {
    this.getCourses()
    this.getDemandes()
  },
  methods: {
    dateFormat(varDate) {
      if (varDate != '') {
        const newDate = new Date(varDate)
        if (newDate) return moment(newDate).format('DD/MM/YYYY')
      }
    },
    getCourses() {
      this.resIsLoading = true;
      this.axios.get('/api/courses?utilisateur=' + this.$store.getters.user.name + '&statut=[Chargement en attente, Transport en cours]')
        .then((response) => {
          this.courses = response.data.data;
          this.resIsLoading = false;
        })
        .catch((error) => {
          console.error('Erreur lors de la récupération des cours :', error);
          this.resIsLoading = false;
        });
    },
    getDemandes() {
      this.resIsLoading = true;
      this.axios.get('/api/demandes?utilisateur=' + this.$store.getters.user.name + '&statut=Recherche en cours&req_count=1')
        .then((response) => {
          this.demandes = response.data;
          this.resIsLoading = false;
        })
        .catch((error) => {
          console.error('Erreur lors de la récupération des cours :', error);
          this.resIsLoading = false;
        });
    },
    Nbjours(debut, fin) {
      const date_dechargement = new Date(fin);
      const date_chargement = new Date(debut);
      const difference = date_dechargement - date_chargement;
      return parseInt(difference / (1000 * 60 * 60 * 24));
    }
  },

})

</script>

<style scoped>
.custom-card {
  height: 280px;
  background: url('@/assets/img_accueil.png') no-repeat center left;
  background-size: cover;
  transition: background-position 0.3s ease-in-out;
}

.custom-card:hover {
  background-position: center right;
}

.customs-card {
  background-color: #007bff;
  height: 200px;
  border: none;
  position: relative;
  display: flex;
  align-items: center;
}

/* .left-side,
.right-side {
  height: 100%;
} */



@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}



.divider {
  position: absolute;
  top: 20px;
  /* Ajuster cette valeur pour la position de début */
  bottom: 100px;
  /* Ajuster cette valeur pour la position de fin */
  left: 50%;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  /* Couleur très légère pour presque invisible */
}

/* Style pour les titres des sections */


.dropdown-arrow {
  transition: transform 0.3s ease;

}

.dropdown-arrow i {
  font-size: 0.8rem;
  color: #007bff;
}



/* Styles pour la card des statistiques */
.stats-card {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stats-card .card-body {
  padding: 1.5rem;
}

.transport-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 1rem;
}

.stat-icon {
  margin-bottom: 0.5rem;
}

.icon-stats {
  width: 40px;
  height: auto;
}

.stat-content {
  text-align: left;
}

.stat-title {
  font-size: 0.8rem;
  opacity: 0.8;
  margin-bottom: 0.25rem;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.25rem;
}

.stat-subtitle {
  font-size: 0.75rem;
  opacity: 0.7;
}

.card-footer {
  background-color: rgba(0, 0, 0, 0.1);
  border-top: none;
  text-align: right;
  padding: 0.75rem 1.5rem;
}

.btn-historique {
  color: white;
  text-decoration: none;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
}

.btn-historique:hover {
  color: rgba(255, 255, 255, 0.8);
}

/* Ligne verticale entre les deux sections */
.col-md-6:first-child {
  position: relative;
}

.col-md-6:first-child:after {
  content: '';
  position: absolute;
  top: 10%;
  right: 0;
  height: 80%;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.2);
}

/* Rendre les sections plus espacées sur mobile */
@media (max-width: 768px) {
  .transport-section {
    padding: 1rem 0;
    align-items: center;
    text-align: center;
  }

  .stat-content {
    text-align: center;
  }

  .col-md-6:first-child:after {
    display: none;
  }

  .col-md-6:first-child {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
}

/* Style uniforme pour les icônes Lottie */
.lottie-icon {
  width: 60px;
  height: 60px;
  display: block;
}
</style>